import React from 'react'

const SignedOut = () => {
  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-body p-4 text-center">
              <div className="mb-4">
                <img
                  src="/GuideSmart_logo-789x221.png"
                  alt="GuideSmart Logo"
                  className="img-fluid mb-3"
                  style={{ maxHeight: '80px' }}
                />
                <h3 className="mb-1">You&apos;ve been signed out</h3>
                <p className="text-muted">Thank you for using GuideSmart. You have been securely signed out.</p>
              </div>
              <a href="/signin" className="btn btn-primary btn-block w-100">
                Sign In Again
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignedOut
